import { RawDocuments } from "../shared-components/raw-documents";
import { DocumentReference } from "@medplum/fhirtypes";
import { SearchDocsFilters } from "../shared-logic/useQueryDocuments";
import { MappedConsolidatedResources } from "../shared-logic/consolidated-context/reducer";
import { useMemo, useState } from "react";

export function PreviewRawDocuments({
  consolidatedState,
  isLimited = false,
}: {
  consolidatedState: MappedConsolidatedResources;
  isLimited?: boolean;
}) {
  const [searchFilters, setSearchFilters] = useState<SearchDocsFilters | undefined>(undefined);

  const documents = useMemo(() => {
    if (consolidatedState?.["DocumentReference"]) {
      return Object.values(consolidatedState?.["DocumentReference"]) as DocumentReference[];
    }
    return [];
  }, [consolidatedState]);

  return (
    <RawDocuments
      searchDocFilters={searchFilters}
      documents={documents}
      isListingDocuments={false}
      actions={{
        onSearchDocuments: async function (filters: SearchDocsFilters) {
          setSearchFilters(filters);
        },
      }}
      isLimited={isLimited}
    />
  );
}
